import { DssDialogModule } from "@dss/components/dialog";
import { NO_ERRORS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PageComponent } from "./page.component";
import { DssTypographyModule } from "@dss/components/typography";
import { TrackingModule } from "../../directives/tracking.module";
import { ButtonModule } from "../forms/button/button.module";
@NgModule({
    declarations: [PageComponent],
    imports: [
        CommonModule,
        DssTypographyModule,
        TrackingModule,
        ButtonModule,
        DssDialogModule,
    ],
    exports: [PageComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class PageModule {}

